export default __webpack_public_path__ + "static/media/grafema_ss-wedding-identity_07.d8f84b44.jpg";